import { Form } from '../core'

$.fn.NewsletterForm = function() {
  let self = this
  self.section = self.closest('.newsletter')
  self.form = undefined

  self.initialize_form = function() {
    self.form = new Form(self.get(0), {
      ajax_redirect: false,
      auto_scroll: false,
      floating_labels: true,
      onSubmit: function() {
        $('.form-success').slideUp(function() {
          $(this).remove();
        })
      },
      onSuccess: function() {
        self.form.getForm().enable_fields()
        self.find('input[name="email_address"]').val('').trigger('blur')
        self.find('input[name="email_address"]').closest('.field').removeClass('field--populated field--focused')
        let $success = $('<p class="form-success form-success--newsletter">')
        $success.html('Merci! Tu fais maintenant partie<br>de notre liste d’envoi.').hide()
        self.after($success.fadeIn(250))
      },
      onError: function() {
        requestAnimationFrame(function() {
          self.removeClass('newsletter-form--blocked')
          self.find('.form-error--invisible').removeClass('form-error--invisible')
          self.find('.field-error--invisible').removeClass('field-error--invisible')
        })
      },
    })
  }

  return function() {
    self.initialize_form()
    return self
  }()
}
